// styles/base/previewFonts.ts
/**
 * The stylesheets for the typeface previews (`FONT_PREVIEWS` in tokens.ts). Each is a dynamic
 * import, so Vite splits it out and a browser downloads only the face it is previewing; production
 * never previews, so never fetches any of them.
 */
import { fontPreview, type FontPreview } from './tokens';

export const PREVIEW_FONT_CSS: Record<Exclude<FontPreview, 'default'>, () => Promise<unknown>> = {
    outfit: () => import('@fontsource-variable/outfit/index.css'),
    jost: () => import('@fontsource-variable/jost/index.css'),
    urbanist: () => import('@fontsource-variable/urbanist/index.css'),
    quicksand: () => import('@fontsource-variable/quicksand/index.css'),
    nunito: () => import('@fontsource-variable/nunito/index.css'),
    lexend: () => import('@fontsource-variable/lexend/index.css'),
};

/** Load the face this browser is previewing, if any */
export const loadPreviewFont = (): void => {
    if (fontPreview !== 'default') void PREVIEW_FONT_CSS[fontPreview]();
};

/** Load every face, for the style sheet's specimens */
export const loadAllPreviewFonts = (): Promise<unknown> =>
    Promise.all(Object.values(PREVIEW_FONT_CSS).map((load) => load()));
